import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10daf4be&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../../../../styles/table.less?vue&type=style&index=0&id=10daf4be&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=10daf4be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10daf4be",
  null
  
)

export default component.exports